var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2577 7.11057L9.40205 10.491L13.7444 7.11057C13.8244 7.04391 13.9167 6.99369 14.0162 6.96278C14.1156 6.93187 14.2202 6.92088 14.3238 6.93044C14.4275 6.94 14.5283 6.96992 14.6204 7.01849C14.7125 7.06706 14.7942 7.13332 14.8606 7.21349C14.9786 7.35592 15.0431 7.53518 15.0427 7.72015C15.0429 7.83646 15.0174 7.95138 14.9682 8.05673C14.9189 8.16209 14.8471 8.2553 14.7577 8.32974L10.0077 12.2881C9.96992 12.3147 9.93023 12.3385 9.88895 12.3593C9.84937 12.4147 9.82562 12.4147 9.78603 12.4147C9.69526 12.4506 9.59864 12.4694 9.50103 12.4702C9.40343 12.4694 9.3068 12.4506 9.21603 12.4147C9.17645 12.3593 9.1527 12.3593 9.11312 12.3593C9.07184 12.3385 9.03215 12.3147 8.99437 12.2881L4.24437 8.32974C4.08269 8.19536 3.98102 8.00226 3.96172 7.79293C3.94242 7.58359 4.00707 7.37516 4.14145 7.21349C4.27583 7.05182 4.46892 6.95015 4.67826 6.93085C4.8876 6.91154 5.09603 6.97619 5.2577 7.11057Z",
    fill: "#64637D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.18f328846b2e0fcb25c3cdadea475d20.svg";
export { ForwardRef as ReactComponent };